// extracted by mini-css-extract-plugin
module.exports = {"cls1":"CinePlayer-CssProp1_div-module--cls1--3j7x5","cls2":"CinePlayer-CssProp1_div-module--cls2--2JGX7 CinePlayer-CssProp1_div-module--cls1--3j7x5"};